import { Fund, NestedKeyOf } from "creso-core/types";
import get from "lodash/get";
import { formatAsPercentage } from "creso-core/utils";
import { AmcLogo } from "@core/components/logo/amc-logo";
import { historicalReturnsRowConfig } from "./config";

export function HistoryReturnsCell({
  label,
  fund,
}: {
  label: string;
  fund?: Fund;
}) {
  if (!fund) {
    return <span className="text-sm">N/A</span>;
  }

  const accessor = historicalReturnsRowConfig.find(
    (config) => config.label === label
  )?.accessor as NestedKeyOf<Fund>;

  if (accessor === "legal_name") {
    return (
      <div className="flex items-center gap-2">
        <AmcLogo amc_code={fund.provider_company_id ?? null} />
        <span className="text-sm">{fund.fund_name}</span>
      </div>
    );
  }

  return (
    <span className="text-sm text-left">
      {formatAsPercentage(get(fund, accessor) as string, "N/A")}
    </span>
  );
}
